"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alarms = exports.AlarmPage = exports.Alarm = exports.Errors = exports.ErrorItem = exports.Events = exports.Event = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const date_1 = require("../../../../../../../date");
const Entity = __importStar(require("../../../../../../../entity"));
const Json = __importStar(require("../../../../../../../json"));
const Device = __importStar(require("../../../../../../device"));
const User = __importStar(require("../../../../../../user"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Device.Log.Schema';
const EventComp = effect_1.Schema.Struct({
    auth: effect_1.Schema.Boolean,
    enhanced: effect_1.Schema.Boolean,
}).annotations({
    identifier: `${exports.NAMESPACE}.EventComp`,
});
/**
 * One history_events document, after Cosmos system fields are removed.
 * The handler does not decode the row. `name` is the event tag; the body is the
 * event without `_tag`. `comp` is stored for drinkDispensed. `channel` is kept
 * from the hub message.
 */
exports.Event = effect_1.Schema.extend(Device.Capability.Event.Event.pipe(effect_1.Schema.omit('_tag')), effect_1.Schema.Struct({
    id: effect_1.Schema.String,
    deviceId: Device.Class.Common.Id,
    createdAt: Entity.CreatedAt,
    name: effect_1.Schema.String,
    channel: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    comp: effect_1.Schema.optionalWith(EventComp, { exact: true }),
})).annotations({
    identifier: `${exports.NAMESPACE}.Event`,
    description: 'One device history event from the last 30 days, in the stored shape.',
});
exports.Events = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(exports.Event),
}).annotations({
    identifier: `${exports.NAMESPACE}.Events`,
});
/**
 * One history_errors document, after Cosmos system fields are removed.
 * `storeError` keeps the hub message, renames errorName to name, and sets
 * dismissed and dismissedAt. There is no domain schema for this collection.
 */
exports.ErrorItem = effect_1.Schema.Struct({
    id: effect_1.Schema.String,
    deviceId: Device.Class.Common.Id,
    name: effect_1.Schema.String,
    createdAt: Entity.CreatedAt,
    time: date_1.Timestamp,
    dismissed: effect_1.Schema.Boolean,
    dismissedAt: effect_1.Schema.NullOr(date_1.DateFromUtcIsoDateString),
    channel: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    message: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }),
    params: effect_1.Schema.optionalWith(Json.Record, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.ErrorItem`,
    description: 'One device history error from the last 30 days, in the stored shape.',
});
exports.Errors = effect_1.Schema.Struct({
    items: effect_1.Schema.Array(exports.ErrorItem),
}).annotations({
    identifier: `${exports.NAMESPACE}.Errors`,
});
/**
 * One alarm as `encodePagedAsync` writes it.
 * This is the database form: `name` and `params`, not the domain `{ alarm: { _tag, params } }`.
 * `updatedAt` is the stored value, or `createdAt` when the stored row omitted it.
 */
exports.Alarm = effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    createdAt: Entity.CreatedAt,
    updatedAt: Entity.UpdatedAt,
    time: date_1.Timestamp,
    deviceId: Device.Class.Common.Id,
    model: effect_1.Schema.optionalWith(Device.Class.Common.ModelCode, { exact: true }),
    dismissedBy: effect_1.Schema.optionalWith(User.Id, { exact: true }),
    name: Device.Capability.Alarm.AlarmTag,
    params: effect_1.Schema.optionalWith(Json.Record, { exact: true }),
    dismissedAt: effect_1.Schema.NullOr(date_1.DateFromUtcIsoDateString),
    dismissed: effect_1.Schema.Boolean,
}).annotations({
    identifier: `${exports.NAMESPACE}.Alarm`,
    description: 'Alarm history row returned by the service-menu log. name is the alarm tag. params is omitted when the alarm has none.',
});
/** Page `toPageResult` keeps. The repository `provider` field is dropped before the response. */
exports.AlarmPage = effect_1.Schema.Struct({
    itemsCount: effect_1.Schema.Int,
    pagesCount: effect_1.Schema.Int,
    page: effect_1.Schema.Int,
    items: effect_1.Schema.Array(exports.Alarm),
}).annotations({
    identifier: `${exports.NAMESPACE}.AlarmPage`,
});
/** Alarms are nested: `data.items` is the page, not the array. */
exports.Alarms = effect_1.Schema.Struct({
    items: exports.AlarmPage,
}).annotations({
    identifier: `${exports.NAMESPACE}.Alarms`,
    description: 'Recent alarms. items is the page (itemsCount, pagesCount, page, items), ' +
        'not the alarm array itself. Orphan alarms stay in the page.',
});
//# sourceMappingURL=schema.js.map